import apiClient from "./apiClient";

const endpoints = { base: "/admin/page" };

// map to exactly what the backend accepts
const normalizeStatus = (s) => (String(s || "").toLowerCase() === "publish" ? "Publish" : "UnPublish");

export async function getAllPages({ signal } = {}) {
  const res = await apiClient.get(endpoints.base, { signal });
  return res.data;                // -> { statusCode, success, message, data:[...], errors:{} }
}

export async function addPage({ title, description, status }, { signal } = {}) {
  const payload = {
    title: String(title || "").trim(),
    description: String(description || ""),
    status: normalizeStatus(status),
  };
  const res = await apiClient.post(endpoints.base, payload, { signal });
  return res.data;
}

export async function updatePage({ id, title, description, status }, { signal } = {}) {
  const payload = {
    id,
    title: String(title || "").trim(),
    description: String(description || ""),
    status: normalizeStatus(status),
  };
  const res = await apiClient.put(endpoints.base, payload, { signal });
  return res.data;
}

export async function deletePage({ id }, { signal } = {}) {
  const res = await apiClient.delete(endpoints.base, { signal, data: { id } });
  return res.data;
}
